import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import { DayBarChart } from "~/components/day-bar-chart";
import {
  type DayCount,
  fillDateGaps,
  chartDateRange,
} from "~/lib/shared/day-chart";
import { orange } from "~/lib/ui";

export const getIntakesByDay = createServerFn({ method: "GET" }).handler(
  async (): Promise<Array<DayCount>> => {
    const { getDBWithInit } = await import("~/lib/db");
    const { intakeResponses } = await import("~/../drizzle/schema");
    const { sql, and, gte, lt } = await import("drizzle-orm");

    const { rangeStart, rangeEnd } = chartDateRange(30, 0);
    const db = await getDBWithInit();

    const rows = await db
      .select({
        date: sql<string>`DATE(${intakeResponses.createdAt})`.as("date"),
        count: sql<number>`COUNT(*)::int`.as("count"),
      })
      .from(intakeResponses)
      .where(
        and(
          gte(intakeResponses.createdAt, rangeStart),
          lt(intakeResponses.createdAt, rangeEnd),
        ),
      )
      .groupBy(sql`DATE(${intakeResponses.createdAt})`)
      .orderBy(sql`DATE(${intakeResponses.createdAt})`);

    return fillDateGaps(rows, {
      daysBefore: 30,
      daysAfter: 0,
      pastColor: orange[600],
      futureColor: orange[400],
    });
  },
);

function IntakeChartPage() {
  const { data } = Route.useLoaderData();
  return <DayBarChart data={data} noun="Intakes" rangeLabel="last 30 days" />;
}

export const Route = createFileRoute("/embed/intake-chart/")({
  head: () => ({
    title: "Intake Chart - Dream Coach Match",
    meta: [
      {
        name: "description",
        content: "Embedded chart showing completed intake flows over time",
      },
    ],
  }),
  loader: async () => {
    const data = await getIntakesByDay();
    return { data };
  },
  component: IntakeChartPage,
});
